import { Itinerary, Status } from './itineray.model';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'itinerarySortByStatus'
})
export class ItinerarySortByStatusPipe implements PipeTransform {

  private statuses = [];

  constructor() {
    for (const key in Status) {
      this.statuses.push(key);
    }
  }

  transform(value: any, ...args: any[]): any {
    if (value && value.sort) {
      const itineraries = value as Itinerary[];
      return itineraries.sort((a, b) => {
        const aIndex = this.statuses.indexOf(a.status);
        const bIndex = this.statuses.indexOf(b.status);
        if (aIndex > bIndex) {
          return 1;
        } else
          if (aIndex < bIndex) {
            return -1;
          } else {
            return 0;
          }

      });
    } else {
      return value;
    }
  }
}
